import moment from 'moment'

const STATIC_FORMAT_DATE = 'DD/MM/YYYY'
const STATIC_FORMAT_TIME_DATE = 'DD/MM/YYYY HH:mm'
const STATIC_FORMAT_DATE_SQL = 'YYYY-MM-DD'
const STATIC_FORMAT_DATE_TIME_ZONE = 'YYYY-MM-DD HH:mm:ss.SSSZZZ'
const STATIC_FORMAT_DATE_TIME_ZONE_T = 'YYYY-MM-DDTHH:mm:ss.sssZ'

/**
 * Format date
 * @param {*} date
 * @param {*} fromFormat
 * @param {*} toFormat
 */
const formatDate = function (date, fromFormat, toFormat) {
  if (date === '') {
    return ''
  }
  return moment(date, fromFormat).format(toFormat)
}

const getRemainDays = function (endDate) {
  endDate = formatDate(
    endDate,
    STATIC_FORMAT_DATE,
    STATIC_FORMAT_DATE_SQL
  );
  var end = moment(endDate); // another date
  var now = moment(new Date()); // todays date
  var duration = moment.duration(end.diff(now));
  var miliseconds = duration.asMilliseconds();
  // Time calculations for days, hours, minutes and seconds
  let days = Math.floor(miliseconds / (1000 * 60 * 60 * 24));
  return days;
}

export default {
  // Static variable
  STATIC_FORMAT_DATE,
  STATIC_FORMAT_DATE_SQL,
  STATIC_FORMAT_DATE_TIME_ZONE,
  STATIC_FORMAT_DATE_TIME_ZONE_T,
  STATIC_FORMAT_TIME_DATE,
  // Function
  formatDate,
  getRemainDays
}
